import { render, staticRenderFns } from "./RModal.vue?vue&type=template&id=ed69bcd8&scoped=true&"
import script from "./RModal.vue?vue&type=script&lang=js&"
export * from "./RModal.vue?vue&type=script&lang=js&"
import style0 from "./RModal.vue?vue&type=style&index=0&id=ed69bcd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed69bcd8",
  null
  
)

export default component.exports